import { createFileRoute } from '@tanstack/react-router'
import { NavyShipDatabase } from 'pages/shipDatabase/NavyShipDatabase'
import type { FC } from 'react'
import { shipsSearchParams } from 'routes/ships/-searchParams'

const RouteComponent: FC = () => {
  const searchParams = Route.useSearch()

  return (
    <NavyShipDatabase
      siteId={searchParams.siteId}
      searchParams={searchParams}
    />
  )
}

export const Route = createFileRoute('/ships/')({
  component: RouteComponent,
  staticData: {
    title: 'Ships',
  },
  validateSearch: shipsSearchParams,
})
